/* global __webpack_hash__ */
// Detecta si hay un frontend nuevo desplegado comparando el hash con el que se
// compiló esta pestaña contra /version.json. Nunca recarga por su cuenta: sólo
// prende `updateAvailable`; recargar lo decide el usuario
// (docs/aviso-nueva-version-spec.md, RN-1).
import { ref } from 'vue'

const ENABLED = process.env.NODE_ENV === 'production'
const CURRENT_BUILD = __webpack_hash__
const VERSION_URL = `${process.env.BASE_URL || '/'}version.json`
const INTERVAL_MS = 10 * 60 * 1000

export const updateAvailable = ref(false)

let checking = false
let started = false

export async function checkForUpdate() {
  if (!ENABLED || updateAvailable.value || checking) return
  checking = true
  try {
    const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: 'no-store' })
    if (!response.ok) return
    const data = await response.json()
    if (data?.build && data.build !== CURRENT_BUILD) {
      updateAvailable.value = true
    }
  } catch {
    // Sin red o servidor caído: no se avisa nada (RN-6).
  } finally {
    checking = false
  }
}

export function startVersionWatch() {
  if (!ENABLED || started) return
  started = true

  checkForUpdate()
  window.setInterval(() => {
    if (document.visibilityState === 'visible') checkForUpdate()
  }, INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkForUpdate()
  })
  window.addEventListener('focus', checkForUpdate)
}

export async function applyUpdate() {
  try {
    if ('caches' in window) {
      const keys = await window.caches.keys()
      await Promise.all(keys.map((key) => window.caches.delete(key)))
    }
  } catch {
    // Si la limpieza falla, la recarga igual trae el index.html nuevo.
  }
  window.location.reload()
}

export function isChunkLoadError(error) {
  return error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || '')
}
